import { IBook } from './types';
import { getBookTextInputData } from './inputs/text/utils';
import { getBookPriceData } from './prices/utils';
import {
  INPUT_NAME_GENDER,
  INPUT_NAME_HERO_NAME,
  INPUT_VALUE_GENDER_GRANDPA,
  INPUT_VALUE_GENDER_GRANDMA,
  INPUT_NAME_GRANDCHILDREN_HOW_MANY,
  BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
  BOOK_PRICE_STORY_OF_GRANDPA_GRANDMA,
  BOOK_PRICE_STORY_OF_GRANDPA_GRANDMA_HARD_COVER,
  INPUT_NAME_SKIN_COLOR,
  INPUT_VALUE_HAIR_COLOR_SOGG_C1,
  INPUT_VALUE_HAIR_COLOR_SOGG_C2,
  INPUT_VALUE_HAIR_COLOR_SOGG_C3,
  INPUT_VALUE_HAIR_COLOR_SOGG_C4,
  INPUT_VALUE_HAIR_COLOR_SOGG_C5,
  INPUT_NAME_HAIR_COLOR_YONG,
  INPUT_NAME_HAIR_COLOR,
  INPUT_VALUE_SKIN_COLOR_SOGG_C1,
  INPUT_VALUE_SKIN_COLOR_SOGG_C2,
  INPUT_VALUE_SKIN_COLOR_SOGG_C3,
  INPUT_VALUE_SKIN_COLOR_SOGG_C4,
  INPUT_NAME_HAIR_STYLE,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
  INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
  INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
  INPUT_NAME_BEARD_STYLE,
  INPUT_VALUE_BEARD_STYLE_SOGG_B1,
  INPUT_VALUE_BEARD_STYLE_SOGG_B2,
  INPUT_VALUE_BEARD_STYLE_SOGG_B3,
  INPUT_NAME_GLASSES,
  INPUT_NAME_GRANDCHILDREN_NAME_1,
  INPUT_NAME_GRANDCHILDREN_NAME_2,
  INPUT_NAME_GRANDCHILDREN_NAME_3,
  INPUT_VALUE_BEARD_STYLE_SOGG_NONE,
  INPUT_NAME_LIKE,
  INPUT_NAME_DISLIKE,
} from '@shared/book/constants';
import { EBookBannerTextColor, EBookBannerTextSize } from './banner/types';
import { EBookDescriptionTextItemType } from './desicription/types';
import { getBookNameValidatorList } from 'src/app/validators';
import { GET_BOOK_NAME_ERROR } from 'src/app/validators.constants';
import { getBookSelectInputData, getBookSelectInputOptionData } from './inputs/select/utils';
import { getFilledNumbersArray } from 'app/shared/timepicker-select/timepicker-select.data';
import { getBookCheckboxInputData } from './inputs/checkbox/utils';
import { getBookCanvasInputData } from './inputs/canvas/utils';
import { bookInputShowWhen, bookInputsToNameValueMap } from './inputs/utils';
import {
  TSkinColorSOGG,
  TSHairColorSOGG,
  TGenderGrandpaGrandma,
  THairStyleSOGG,
  TBeardStyleSOGG
} from '@shared/book/interfaces';
import { IBookCanvasInputItem } from './inputs/canvas/types';
import { getBookRadioColorInputData, getBookRadioColorInputOptionData } from './inputs/radioColor/utils';
import { INPUT_NAME_RESERVED_GROUP1 } from './inputs/group/constants';
import { INPUT_NAME_RESERVED_CANVAS1 } from './inputs/canvas/constants';
import { getBookGroupInputData } from './inputs/group/utils';
import { getBookRadioIconInputData, getBookRadioIconInputOptionData } from './inputs/radioIcon/utils';
import { getBookMultiselectInputData, getBookMultiselectInputOptionData } from './inputs/multiselect/utils';
import { dislikeSoggArr, likeSoggArr } from '@shared/book/data';

export const StoryOfGrandpaGrandmaInputsHeroName = getBookTextInputData({
  label: 'book7.hero.name',
  placeholder: 'ひらがな９文字まで',
  // value: '',
  name: INPUT_NAME_HERO_NAME,
  validator: getBookNameValidatorList(9),
  error: GET_BOOK_NAME_ERROR(9),
});

export const StoryOfGrandpaGrandmaInputsGender = getBookSelectInputData({
  // selectType: EBookSelectInputType.imageText,
  label: 'Gender',
  placeholder: 'Please choose',
  options: [
    getBookSelectInputOptionData({
      label: 'Grandpa',
      // imgSrc: '/assets/images/radio-boy.png',
      value: INPUT_VALUE_GENDER_GRANDPA
    }),
    getBookSelectInputOptionData({
      label: 'Grandma',
      // imgSrc: '/assets/images/radio-girl.png',
      value: INPUT_VALUE_GENDER_GRANDMA
    }),
  ],
  value: '',
  name: INPUT_NAME_GENDER,
});

export const StoryOfGrandpaGrandmaInputsKids = getBookSelectInputData({
  label: 'Kids count',
  placeholder: 'Please choose',
  options: getFilledNumbersArray(1, 3, 1).map(
    (value) => getBookSelectInputOptionData({ label: `${value}人`, value }),
  ),
  value: '',
  name: INPUT_NAME_GRANDCHILDREN_HOW_MANY,
});

// * canvas inputs
export const StoryOfGrandpaGrandmaInputsSkinColor = getBookRadioColorInputData({
  label: 'Skin color',
  options: [
    getBookRadioColorInputOptionData({
      color: '#FFEAD6',
      value: INPUT_VALUE_SKIN_COLOR_SOGG_C1,
    }),
    getBookRadioColorInputOptionData({
      color: '#FAD5A2',
      value: INPUT_VALUE_SKIN_COLOR_SOGG_C2,
    }),
    getBookRadioColorInputOptionData({
      color: '#CF9970',
      value: INPUT_VALUE_SKIN_COLOR_SOGG_C3,
    }),
    getBookRadioColorInputOptionData({
      color: '#B28262',
      value: INPUT_VALUE_SKIN_COLOR_SOGG_C4,
    }),
  ],
  value: INPUT_VALUE_SKIN_COLOR_SOGG_C1,
  name: INPUT_NAME_SKIN_COLOR,
});

export const StoryOfGrandpaGrandmaInputsHairColor = getBookRadioColorInputData({
  label: 'Hair color',
  options: [
    getBookRadioColorInputOptionData({
      color: '#F8D992',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }),
    getBookRadioColorInputOptionData({
      color: '#CF744B',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }),
    getBookRadioColorInputOptionData({
      color: '#9F6D48',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }),
    getBookRadioColorInputOptionData({
      color: '#4D423B',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }),
    getBookRadioColorInputOptionData({
      color: '#E4DED6',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }),
  ],
  value: INPUT_VALUE_HAIR_COLOR_SOGG_C1,
  name: INPUT_NAME_HAIR_COLOR,
});

export const StoryOfGrandpaGrandmaInputsHairColorYoung = getBookRadioColorInputData({
  label: 'Hair color in childhood',
  options: [
    getBookRadioColorInputOptionData({
      color: '#F8D992',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }),
    getBookRadioColorInputOptionData({
      color: '#CF744B',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }),
    getBookRadioColorInputOptionData({
      color: '#9F6D48',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }),
    getBookRadioColorInputOptionData({
      color: '#4D423B',
      value: INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }),
  ],
  value: INPUT_VALUE_HAIR_COLOR_SOGG_C1,
  name: INPUT_NAME_HAIR_COLOR_YONG,
});

export const StoryOfGrandpaGrandmaInputsHairStyleGrandpa = getBookRadioIconInputData({
  label: 'Hair style',
  options: [
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H01-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H02-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H03-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H04-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H05-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H06-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
  name: INPUT_NAME_HAIR_STYLE,
});

export const StoryOfGrandpaGrandmaInputsHairStyleGrandma = getBookRadioIconInputData({
  label: 'Hair style',
  options: [
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H07-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H08-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H09-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H10-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H11-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-H12-min.png',
      value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
  name: INPUT_NAME_HAIR_STYLE,
});

export const StoryOfGrandpaGrandmaInputsBeardStyle = getBookRadioIconInputData({
  label: 'Beard style',
  options: [
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-B00-min.png',
      value: INPUT_VALUE_BEARD_STYLE_SOGG_NONE,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-B01-min.png',
      value: INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-B02-min.png',
      value: INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }),
    getBookRadioIconInputOptionData({
      imgSrc: '/assets/images/sogg-canvas/form-icons/icon-B03-min.png',
      value: INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }),
  ],
  value: INPUT_VALUE_BEARD_STYLE_SOGG_NONE,
  name: INPUT_NAME_BEARD_STYLE,
});

export const StoryOfGrandpaGrandmaInputsGlasses = getBookCheckboxInputData({
  label: 'メガネをかける',
  name: INPUT_NAME_GLASSES,
  value: false,
} as const);

// * canvas common
const StoryOfGrandpaGrandmaInputsCanvasCommon = {
  width: 359,
  height: 586,
  crop: {
    top: 15,
    right: 20,
    bottom: 18,
    left: 23,
  },
  cropLtMd: {
    top: 15,
    left: 76,
    bottom: 361,
  },
  name: INPUT_NAME_RESERVED_CANVAS1,
} as const;

// * grandpa canvas
const StoryOfGrandpaGrandmaInputsCanvasGrandpaInputs = [
  StoryOfGrandpaGrandmaInputsSkinColor,
  StoryOfGrandpaGrandmaInputsHairColor,
  StoryOfGrandpaGrandmaInputsHairColorYoung,
  StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
  StoryOfGrandpaGrandmaInputsBeardStyle,
  StoryOfGrandpaGrandmaInputsGlasses,
];

const StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsSkin: IBookCanvasInputItem[] = [
  {
    imgSrc: '/assets/images/sogg-canvas/M/web-M01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C1,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C2,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C3,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C4,
    }],
  },
];

const StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsHair: IBookCanvasInputItem[] = [
  {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H04-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandpa,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDPA_H06,
    }]
  },
];

const StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsBeard: IBookCanvasInputItem[] = [
  {
    imgSrc: '/assets/images/sogg-canvas/B/web-C01-B01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C01-B02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C01-B03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C02-B01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C02-B02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C02-B03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C03-B01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C03-B02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C03-B03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C04-B01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C04-B02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C04-B03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C05-B01-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B1,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C05-B02-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B2,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/B/web-C05-B03-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsBeardStyle,
      condition: (v: TBeardStyleSOGG) => v === INPUT_VALUE_BEARD_STYLE_SOGG_B3,
    }]
  },
];

export const StoryOfGrandpaGrandmaInputsCanvasGrandpa = getBookCanvasInputData({
  ...StoryOfGrandpaGrandmaInputsCanvasCommon,
  label: 'book7.input.canvas.title.grandpa',
  inputs: StoryOfGrandpaGrandmaInputsCanvasGrandpaInputs,
  items: [
    ...StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsSkin,
    ...StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsHair,
    ...StoryOfGrandpaGrandmaInputsCanvasGrandpaItemsBeard,
    {
      imgSrc: '/assets/images/sogg-canvas/G/web-G01-min.png',
      showWhen: [{
        inputToCheck: StoryOfGrandpaGrandmaInputsGlasses,
        condition: (v: boolean) => v,
      }],
    },
  ],
  value: bookInputsToNameValueMap(StoryOfGrandpaGrandmaInputsCanvasGrandpaInputs),
});

// * grandma canvas
const StoryOfGrandpaGrandmaInputsCanvasGrandmaInputs = [
  StoryOfGrandpaGrandmaInputsSkinColor,
  StoryOfGrandpaGrandmaInputsHairColor,
  StoryOfGrandpaGrandmaInputsHairColorYoung,
  StoryOfGrandpaGrandmaInputsHairStyleGrandma,
  StoryOfGrandpaGrandmaInputsGlasses,
];

const StoryOfGrandpaGrandmaInputsCanvasGrandmaItemsSkin: IBookCanvasInputItem[] = [
  {
    imgSrc: '/assets/images/sogg-canvas/M/web-M05-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C1,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M06-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C2,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C3,
    }],
  }, {
    imgSrc: '/assets/images/sogg-canvas/M/web-M08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsSkinColor,
      condition: (v: TSkinColorSOGG) => v === INPUT_VALUE_SKIN_COLOR_SOGG_C4,
    }],
  }
];

const StoryOfGrandpaGrandmaInputsCanvasGrandmaItemsHair: IBookCanvasInputItem[] = [
  {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H09-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H10-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H11-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C01-H12-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C1,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H09-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H10-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H11-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C02-H12-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C2,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H09-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H10-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H11-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C03-H12-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C3,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H09-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H10-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H11-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C04-H12-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C4,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H07-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H01,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H08-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H02,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H09-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H03,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H10-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H04,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H11-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H05,
    }]
  }, {
    imgSrc: '/assets/images/sogg-canvas/C-H/web-C05-H12-min.png',
    showWhen: [{
      inputToCheck: StoryOfGrandpaGrandmaInputsHairColor,
      condition: (v: TSHairColorSOGG) => v === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
    }, {
      inputToCheck: StoryOfGrandpaGrandmaInputsHairStyleGrandma,
      condition: (v: THairStyleSOGG) => v === INPUT_VALUE_HAIR_STYLE_GRANDMA_H06,
    }]
  },
];

export const StoryOfGrandpaGrandmaInputsCanvasGrandma = getBookCanvasInputData({
  ...StoryOfGrandpaGrandmaInputsCanvasCommon,
  label: 'book7.input.canvas.title.grandma',
  inputs: StoryOfGrandpaGrandmaInputsCanvasGrandmaInputs,
  items: [
    ...StoryOfGrandpaGrandmaInputsCanvasGrandmaItemsSkin,
    ...StoryOfGrandpaGrandmaInputsCanvasGrandmaItemsHair,
    {
      imgSrc: '/assets/images/sogg-canvas/G/web-G02-min.png',
      showWhen: [{
        inputToCheck: StoryOfGrandpaGrandmaInputsGlasses,
        condition: (v: boolean) => v,
      }],
    },
  ],
  value: bookInputsToNameValueMap(StoryOfGrandpaGrandmaInputsCanvasGrandmaInputs),
});

// * children name
export const StoryOfGrandpaGrandmaInputsChildren1Name = getBookTextInputData({
  label: 'Grandchild 1 name',
  placeholder: 'ひらがな６文字まで',
  // value: '',
  name: INPUT_NAME_GRANDCHILDREN_NAME_1,
  validator: getBookNameValidatorList(6),
  error: GET_BOOK_NAME_ERROR(6),
});

export const StoryOfGrandpaGrandmaInputsChildren2Name = getBookTextInputData({
  label: 'Grandchild 2 name',
  placeholder: 'ひらがな６文字まで',
  // value: '',
  name: INPUT_NAME_GRANDCHILDREN_NAME_2,
  validator: getBookNameValidatorList(6),
  error: GET_BOOK_NAME_ERROR(6),
});

export const StoryOfGrandpaGrandmaInputsChildren3Name = getBookTextInputData({
  label: 'Grandchild 3 name',
  placeholder: 'ひらがな６文字まで',
  // value: '',
  name: INPUT_NAME_GRANDCHILDREN_NAME_3,
  validator: getBookNameValidatorList(6),
  error: GET_BOOK_NAME_ERROR(6),
});

const StoryOfGrandpaGrandmaInputsGroup1ChildrenInputs = [
  StoryOfGrandpaGrandmaInputsChildren1Name,
];

export const StoryOfGrandpaGrandmaInputsGroup1Children = getBookGroupInputData({
  label: 'bood7.input.group.title.children',
  inputs: StoryOfGrandpaGrandmaInputsGroup1ChildrenInputs,
  value: bookInputsToNameValueMap(StoryOfGrandpaGrandmaInputsGroup1ChildrenInputs),
  name: INPUT_NAME_RESERVED_GROUP1,
});

const StoryOfGrandpaGrandmaInputsGroup2ChildrenInputs = [
  StoryOfGrandpaGrandmaInputsChildren1Name,
  StoryOfGrandpaGrandmaInputsChildren2Name,
];

export const StoryOfGrandpaGrandmaInputsGroup2Children = getBookGroupInputData({
  label: 'bood7.input.group.title.children',
  inputs: StoryOfGrandpaGrandmaInputsGroup2ChildrenInputs,
  value: bookInputsToNameValueMap(StoryOfGrandpaGrandmaInputsGroup2ChildrenInputs),
  name: INPUT_NAME_RESERVED_GROUP1,
});

const StoryOfGrandpaGrandmaInputsGroup3ChildrenInputs = [
  StoryOfGrandpaGrandmaInputsChildren1Name,
  StoryOfGrandpaGrandmaInputsChildren2Name,
  StoryOfGrandpaGrandmaInputsChildren3Name,
];

export const StoryOfGrandpaGrandmaInputsGroup3Children = getBookGroupInputData({
  label: 'bood7.input.group.title.children',
  inputs: StoryOfGrandpaGrandmaInputsGroup3ChildrenInputs,
  value: bookInputsToNameValueMap(StoryOfGrandpaGrandmaInputsGroup3ChildrenInputs),
  name: INPUT_NAME_RESERVED_GROUP1,
});

// * likes/dislikes
// likes
const StoryOfGrandpaGrandmaInputsLikesCommon = {
  options: likeSoggArr.map(like => getBookMultiselectInputOptionData({
    imgSrc: '/assets/images/sogg-likes-dislikes/like-' + like + '.png',
    label: 'book7.like.' + like,
    value: like,
  })),
  name: INPUT_NAME_LIKE,
  min: 3,
  max: 3,
} as const;

export const StoryOfGrandpaGrandmaInputsLikesGrandpa = getBookMultiselectInputData({
  ...StoryOfGrandpaGrandmaInputsLikesCommon,
  label: 'book7.input.likes.title.grandpa',
});

export const StoryOfGrandpaGrandmaInputsLikesGrandma = getBookMultiselectInputData({
  ...StoryOfGrandpaGrandmaInputsLikesCommon,
  label: 'book7.input.likes.title.grandma',
});

// dislikes
const StoryOfGrandpaGrandmaInputsDislikesCommon = {
  options: dislikeSoggArr.map(dislike => getBookMultiselectInputOptionData({
    imgSrc: '/assets/images/sogg-likes-dislikes/dislike-' + dislike + '.png',
    label: 'book7.dislike.' + dislike,
    value: dislike,
  })),
  name: INPUT_NAME_DISLIKE,
  max: 1,
  min: 1,
} as const;

export const StoryOfGrandpaGrandmaInputsDislikesGrandpa = getBookMultiselectInputData({
  ...StoryOfGrandpaGrandmaInputsDislikesCommon,
  label: 'book7.input.dislikes.title.grandpa',
});

export const StoryOfGrandpaGrandmaInputsDislikesGrandma = getBookMultiselectInputData({
  ...StoryOfGrandpaGrandmaInputsDislikesCommon,
  label: 'book7.input.dislikes.title.grandma',
});

// * mutations
bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsHairColorYoung,
  StoryOfGrandpaGrandmaInputsHairColor,
  (hairColor: TSHairColorSOGG) => hairColor === INPUT_VALUE_HAIR_COLOR_SOGG_C5,
);

bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsCanvasGrandpa,
  StoryOfGrandpaGrandmaInputsGender,
  (gender: TGenderGrandpaGrandma) => gender === INPUT_VALUE_GENDER_GRANDPA,
);

bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsCanvasGrandma,
  StoryOfGrandpaGrandmaInputsGender,
  (gender: TGenderGrandpaGrandma) => gender === INPUT_VALUE_GENDER_GRANDMA,
);

bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsGroup1Children,
  StoryOfGrandpaGrandmaInputsKids,
  (count: '1' | '2' | '3') => +count === 1,
);

bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsGroup2Children,
  StoryOfGrandpaGrandmaInputsKids,
  (count: '1' | '2' | '3') => +count === 2,
);

bookInputShowWhen(
  StoryOfGrandpaGrandmaInputsGroup3Children,
  StoryOfGrandpaGrandmaInputsKids,
  (count: '1' | '2' | '3') => +count === 3,
);

const StoryOfGrandpaGrandma: IBook = {
  caption: 'わたしたちの、おじいちゃん/おばあちゃん',
  summary: ['孫のあなた（達）と会えたことは、今までで一番、嬉しいこと。'],
  alias: BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
  prices: [
    ['soft', getBookPriceData(BOOK_PRICE_STORY_OF_GRANDPA_GRANDMA)],
    ['hard', getBookPriceData(BOOK_PRICE_STORY_OF_GRANDPA_GRANDMA_HARD_COVER)],
  ],
  photos: [
    '/assets/images/book7-carousel01.jpg',
    '/assets/images/book7-carousel02.jpg',
    '/assets/images/book7-carousel03.gif',
    '/assets/images/book7-carousel04.jpg',
  ],
  menuPhoto: '/assets/images/cart-product-photo-7.png',
  previewPhoto: '/assets/images/cart-product-photo-7.png',
  properties: {
    purpose: ['Adventure'],
    age: {
      start: 1,
      end: 5,
    },
  },
  notice: {
    caption: 'book7.notice.title',
    description: 'book7.notice.description',
    points: [
      {
        imgSrc: '/assets/images/birthday-notice-point-1.png',
        caption: 'book7.notice.point.1',
      },
      {
        imgSrc: '/assets/images/book7-notice-point-2.png',
        caption: 'book7.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタムができるの？',
      description: 'おじいちゃん・おばあちゃんのイラスト選択、メッセージ編集、写真を入れる、ストーリーを一部編集する、子どもを複数登場させるなど。',
    },
    {
      caption: '絵本のストーリーは？',
      description: 'おじいちゃん・おばあちゃんにも、子どもの時代がありました。好きなことも、嫌いなことも。嬉しいことも、失敗したことも、たくさん。そう、今のあなた達みたいな、子どもだったんですよ。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description: '全28ページ、本文の大きさは幅29.7cm 高さ21cmのA4横。',
    },
  ],
  inputs: [
    StoryOfGrandpaGrandmaInputsHeroName,
    StoryOfGrandpaGrandmaInputsGender,
    StoryOfGrandpaGrandmaInputsKids,
    StoryOfGrandpaGrandmaInputsCanvasGrandpa,
    StoryOfGrandpaGrandmaInputsCanvasGrandma,
    StoryOfGrandpaGrandmaInputsGroup1Children,
    StoryOfGrandpaGrandmaInputsGroup2Children,
    StoryOfGrandpaGrandmaInputsGroup3Children,
  ],
  banner: {
    imgSrc: '/assets/images/book7-banner-desktop.jpg',
    imgSrcLtMd: '/assets/images/book7-banner-mobile.jpg',
    text: 'おじいちゃんの　いまのねがいは、あなたたちが　すこやかに　しあわせに　そだつこと。',
    textColor: EBookBannerTextColor.dark,
    textSize: EBookBannerTextSize.sm,
  },
  description: [
    {
      imgSrc: '/assets/images/book7-images01.gif',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: 'みんな、あなたみたいな子どもだった'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'おじいちゃんにも、おばあちゃんにも、みんなみんな、子どもの時代がありました。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '好きなものも、苦手なものも、嬉しいことも、悲しいことだって。そう、今のあなたみたいなね。',
        },
      ],
    }, {
      imgSrc: '/assets/images/book7-image02.jpg',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '次は、あなたたちのお話を聞かせて'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'この絵本を読む子（孫）を３人まで、絵本に登場させることができます。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'それぞれの子の写真を入れて、みんなで読めば、今日の絵本タイムが盛り上がること、間違いなし！',
        },
      ],
    },
  ],
  reviews: [
    {
      photoImgSrc: '/assets/images/review4.jpg',
      userPhotoImgSrc: '/assets/images/review4-icon.png',
      userName: 'せなくん',
      text: [
        '息子のクリスマスプレゼントで購入🎄🎁',
        '息子が主人公で物語がはじまるとっても素敵な絵本💐',
        '絵も可愛くて息子も母もニコニコ︎︎︎︎︎😀',
        'パパとままもびっくりしてました。',
        '出産祝いにもいいなって思った🕊',
      ],
    }, 
     {
      photoImgSrc: '/assets/images/review1.png',
      userPhotoImgSrc: '/assets/images/review1user.png',
      userName: 'ゆのちゃん',
      text: [
        '「たのしかったです。',
        'えほんがめっちゃかわいいです。',
        'きにいりました。',
        'パパとままもびっくりしてました。',
        'ゆのちゃんのえほんがあるなんておもいもしませんでした。」',
      ],
    },
    {
      photoImgSrc: '/assets/images/review5.jpg',
      userPhotoImgSrc: '/assets/images/review5-icon.png',
      userName: 'はるまくん',
      text: [
        '届いた絵本をさっそく見せたらこんなにニコニコ😊',
        '読み聞かせたら、大好きなトリケラトプスがいて、大喜びでした。自分の誕生日のお話ってわかったかどうか・・。でもケーキの絵を見てハッピーバースデー歌ってました🎂',
        '素敵な絵本ありがとうございました。',
      ],
    },
    {
      photoImgSrc: '/assets/images/review2.png',
      userPhotoImgSrc: '/assets/images/review2user.png',
      userName: 'てんげんくん',
      text: [
        '自分が主人公になれて本の内容も自由に選べるオリジナル絵本📖♥️♥️かわいいっっ📖💓',
      ],
    },
    {
      photoImgSrc: '/assets/images/review3.png',
      userPhotoImgSrc: '/assets/images/review3user.png',
      userName: 'あづきちゃん',
      text: [
        '昨日、絵本届きました。',
        '娘が手に取った瞬間から大喜びでした。',
        '自分の名前と写真が入った、特別な本ということで、何度も何度も読んでいました。',
        'ありがとうございました☺️💕',
      ],
    },
  ],
};

export default StoryOfGrandpaGrandma;
